<ul class="nav navbar-nav navbar-right">
    @if (isVisible()) {
        <li class="login-header">
            <span class="hidden-sm hidden-xs hidden-md"
                >Welcome {{ userName() }} !</span
            >
            <br />
            <div class="hand" (click)="onLogOut()">Sign out</div>
        </li>
    }

    @if (!isVisible()) {
        <li>
            <a class="hand" (click)="onLogin()">Sign in</a>
        </li>
    }
</ul>
